const state = {
  DocstreamSettings: {}
}

const getters = {
  getDocstreamSettings: (state) => { return state.DocstreamSettings }
}

const actions = {
}

const mutations = {
  setDocstreamSettings (state, settings) {
    state.DocstreamSettings = settings
  }
}

export const module = {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/Store/modules/docstreamSettingsModule.js